export const VIEW_OVERRIDE_PREFIX = "view-override-";

export function viewOverrideId(userId: string, viewId: string): string {
  return `${VIEW_OVERRIDE_PREFIX}${userId}-${viewId}`;
}

export function parseViewOverrideId(id: string): { userId: string; viewId: string } | null {
  if (!id.startsWith(VIEW_OVERRIDE_PREFIX)) return null;
  const rest = id.slice(VIEW_OVERRIDE_PREFIX.length);
  const firstDash = rest.indexOf("-");
  if (firstDash === -1) return null;
  return {
    userId: rest.slice(0, firstDash),
    viewId: rest.slice(firstDash + 1),
  };
}
